/** @jsx jsx */
import React, { useState } from 'react'
import { jsx } from 'theme-ui'
import { Txt } from './'
import { useInterval } from 'react-use'

export const PulsingText: React.SFC<{}> = ({ ...props }) => {
  const [isBright, setIsBright] = useState(false)

  useInterval(() => {
    setIsBright(!isBright)
  }, 1000)

  return (
    <Txt
      sx={{
        transition: '.5s all ease-out',
        color: isBright ? 'lightGreen' : 'text',
        transform: isBright ? 'scale(1.05)' : 'scale(1)',
      }}
      {...props}
    />
  )
}
